import { Spinner, IconClose12 } from '@cian/ui-kit';
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { ImagePreview } from '../ImagePreview';
import { OtherFilePreview } from '../OtherFilePreview';
import { PreviewFallback } from '../PreviewFallback';
import * as styles from './FilePreviewsItem.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FilePreviewsItem = function FilePreviewsItem(_ref) {
  var file = _ref.file,
    loading = _ref.loading,
    error = _ref.error,
    onRemove = _ref.onRemove,
    onRetry = _ref.onRetry;
  var mimeType = file.mimeType;
  var PreviewComponent = React.useMemo(function () {
    var isImage = mimeType.startsWith('image/');
    return isImage ? ImagePreview : OtherFilePreview;
  }, [mimeType]);
  return /*#__PURE__*/_jsxs("div", {
    className: cx(styles['container'], loading && styles['loading'], error && styles['error']),
    children: [loading && /*#__PURE__*/_jsx(Spinner, {
      size: 16,
      color: "primary_100"
    }), error && /*#__PURE__*/_jsx(PreviewFallback, {
      onRetry: onRetry
    }), !error && !loading && /*#__PURE__*/_jsx(PreviewComponent, {
      file: file
    }), /*#__PURE__*/_jsx("button", {
      className: styles['delete'],
      type: "button",
      onClick: onRemove,
      "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
      children: /*#__PURE__*/_jsx(IconClose12, {
        color: "white_100"
      })
    })]
  });
};